import React from 'react';
import HR from '../../Components/HR';
import p1 from '../../Media/Benifits/p1.webp'
import p2 from '../../Media/Benifits/p2.webp'
import p3 from '../../Media/Benifits/p3.webp'
import p4 from '../../Media/Benifits/p4.webp'
import p5 from '../../Media/Benifits/p5.webp'
import p6 from '../../Media/Benifits/p6.webp'
import p7 from '../../Media/Benifits/p7.webp'
import p8 from '../../Media/Benifits/p8.webp'
import p9 from '../../Media/Benifits/p9.webp'
import p10 from '../../Media/Benifits/p10.webp'
import p11 from '../../Media/Benifits/p11.webp'
import p12 from '../../Media/Benifits/p12.webp'

const Benefits = () => {
    return (
        <div id='How'>
            <HR>Benefits of Intelligent bots</HR>
            <div className='grid md:grid-cols-12 lg:grid-cols-12 gap-5 mx-auto mt-16 mb-16'>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p1} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Increase Efficiency</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p2} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>100% Accuracy</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p3} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>24 X 7 productivity</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p4} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>24 X 7 productivity</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p5} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Improve time to market</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p6} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Comply with industry
regulations</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p7} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Speed up process time</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p8} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Enhance Visibility</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p9} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Reduce Costs</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p10} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Boost Scalability</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p11} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Optimize Resources</p>
                </div>
                <div className='lg:col-span-3 md:col-span-4 bg-grayBG py-12 rounded-xl'>
                    <div className='flex justify-center'>
                        <img className='w-[70px] h-[70px]' src={p12} alt="" />
                    </div>
                    <p className='text-xl text-center mt-5'>Accelerate digital transformation programmes</p>
                </div>
            </div>
        </div>
    );
};

export default Benefits;